import request from '@/utils/request'
import utils from '@/utils/utils';

/** 获取基本信息 */
export const getBaisc = (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "app.appinfo",
      url:"/app/appinfo",
      data: {
        "userName":utils.getCookie("USER_INFO"),
        "token": utils.getCookie("TOKEN")
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        resolve({success: false,data:res.data})
      }
    })
  })
}

/** 获取订阅 */
export const getSubscription = (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "api.getapplyapiinfos",
      url:'/api/getapplyapiinfos',
      data: {
        "userName":utils.getCookie("USER_INFO"),
        "token": utils.getCookie("TOKEN"),
        "pageNo":self.page,
        "pageSize":self.pageSize
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        resolve({success: false,data:res})
      }
    })
  })
}


/** 获取所有api */
export const getApis = (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "api.apipage",
      url:"/api/apipage",
      data: {
        "status": self.status,
        "userName": utils.getCookie("USER_INFO"),
        "token": utils.getCookie("TOKEN")
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        resolve({success: false,data:res.data})
      }
    })
  })
}

/** 提交订阅审核 */
export const subReview = (self,apiList) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "app.submitapp",
      url:"/app/submitapp",
      data: {
        "userName":utils.getCookie("USER_INFO"),
        "token": utils.getCookie("TOKEN"),
        "apiList":apiList
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        resolve({success: false,data:res.data})
      }
    })
  })
}

/** 删除已订阅 */
export const delApis = (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "app.delapi",
      url:'/app/delapi',
      data: {
        "userName":utils.getCookie("USER_INFO"),
        "token": utils.getCookie("TOKEN"),
        "apiCode":self.del_id,
        "captchaType": "blockPuzzle", //行为校验方式  滑动
        "captcha": self.captcha,
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        self.$message.error(res.message)
        resolve({success: false,data:res.data})
      }
    })
  })
}

//申请中取消订阅
export const cancelApis = (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "app.cancelapi",
      url: '/app/cancelapi',
      data: {
        "userName":utils.getCookie("USER_INFO"),
        "token": utils.getCookie("TOKEN"),
        "apiCode": self.del_id
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        resolve({ success: false, data: res.data })
        self.$message.error(res.message)
      }
    })
  })
}

// 获取短信验证码  删除api验证码
export const getMessageCode= (self) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "common.getmessagecode",
      url:'/common/getmessagecode',
      data: {
        "userName":utils.getCookie("USER_INFO"),
        "token": utils.getCookie('TOKEN'),
        "req_time": self.req_time,
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        self.$message.error(res.message)
      }
    })
  })
}

//已订阅接口编辑IP白名单
export const editip= (self,apiCode,limitIp) => {
  return new Promise((resolve, reject) => {
    request.post(self, {
      action: "api.editip",
      url:'/api/editip',
      data: {
        "userName":utils.getCookie("USER_INFO"),
        "token": utils.getCookie('TOKEN'),
        "apiCode": apiCode,
        'limitIp':limitIp
      }
    }).then(res => {
      if (res.code == 20000) {
        resolve({
          success: true,
          data: res.data
        })
      } else {
        self.$message.error(res.message)
      }
    })
  })
}

//校验ip
export const changeIp = (rule, value, callback) => {
  // const Reg = /((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)/;
  const  Reg= /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if(!value){
    return callback();   
  }else{
    if(Reg.test(value)){
        callback();
    }else{
      if(value == '*'){
        callback();
      }else{
        callback(new Error("请输入正确的指定IP!"));
      }
      
    }
  }
}

//校验ip
export const changeIsip = (rule, value, callback) => {
  const  Reg= /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if(!value){
        callback(new Error("请输入IP地址!"));   
  }else{
    if(Reg.test(value)){
        callback();
    }else{
        callback(new Error("请输入正确的指定IP!"));
    }
  }
}

//数组去空
export const notempty = (array)=>{
    let noemptyArr = array.filter( item=>item)
    return noemptyArr;
}
